import { Component,EventEmitter,Input,OnChanges,OnInit,Output,SimpleChanges, ViewChild } from "@angular/core";
import { ListDataService } from "../services/list-data.service";
import { ScheduleParameters } from "../models/ScheduleParameters";
import { AlertParameters } from "../models/AlertParameters";
import { FormGroup, FormBuilder, FormControl, Validators } from "@angular/forms";
import { MessageService } from "../services/message.service";
import { ScheduleDataService } from "../services/schedule-data.service";
import { Schedule } from "../models/Schedule";
import { forkJoin, of } from "rxjs";
import { FilteredTruckersInfo } from "../models/FilteredTruckersInfo";
import { AlertTruckerUserItem } from "../models/AlertTruckerUserItem";
import { FormStatus } from "../models/Enums";
import { AlertTruckerLocationListItem } from "../models/AlertTruckerLocationListItem";
import { CommodityListItem } from "../models/CommodityListItem";
import { AlertTruckerFilteredTruckersContactInfo } from "../models/AlertTruckerFilteredTruckersInfo";
import { UserDataService } from "../services/user-data.service";

@Component({
    selector: "alert-trucker-form",
    templateUrl: "alert-trucker-form.component.html",
    styles: [`
      .table-striped > tbody > tr:nth-of-type(odd) > td {
        background-color: #ecf6ff;
      }

      .table-striped > tbody > tr.selected-row > td {
        background-color: #d2ddff !important;
      }
    `],
    standalone: false
})
export class AlertTruckerFormComponent implements OnInit, OnChanges {

    @ViewChild("closeButton") closeButton;
    @Input() alertParameters: AlertParameters = new AlertParameters();
    @Input() alertTruckerFormId: string = 'alertTruckerModal';
    @Output() sendComplete: EventEmitter<number> = new EventEmitter<number>();

    emailForm: FormGroup;
    users: AlertTruckerUserItem[];
    searchedUsers: AlertTruckerUserItem[] = [];
    searchTerm: string = '';
    errorMessage: string = "";
    schedule: Schedule = new Schedule();
    response = {
        data: "",
        status: "",
    };
    manuallyCCEnteredEmails: string[] = [];
    manuallyBCCEnteredEmails: string[] = [];
    ccValid: boolean = null;
    bccValid: boolean = null;
    formStatus: FormStatus = FormStatus.Normal;
    FormStatus = FormStatus;
    messageMaxLength = 480;
    truckerSelectedMessage: string;
    isAccordianOpen: boolean = false;
    destinations: AlertTruckerLocationListItem[] = [];
    origins: AlertTruckerLocationListItem[] = [];
    commodities: CommodityListItem[] = [];
    categories = [];
    truckers: AlertTruckerFilteredTruckersContactInfo[];
    selectedTruckerInfoContactList: AlertTruckerFilteredTruckersContactInfo[] = [];
    selectorTitle: string;
    contactAllSelected: boolean = false;
    originAllSelected: boolean = false;
    commoditiesAllSelected: boolean = false;
    destinationAllSelected: boolean = false;
    userToNotifyAll: boolean = false;
    isLoadingTruckerContactInfo: boolean = false;
    constructor(
        private formBuilder: FormBuilder,
        private _messageService: MessageService,
        private _scheduleDataService: ScheduleDataService,
        private _userDataService: UserDataService
    ) { }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["alertParameters"]) {
            this.resetComponent();
            this.emailForm.get("cc")?.valueChanges.subscribe(value => {
                this.updateManuallyCCEnteredEmails(value);
            });

            this.emailForm.get("bcc")?.valueChanges.subscribe(value => {
                this.updateManuallyBCCEnteredEmails(value);
            });

            if (this.alertParameters.scheduleId > 0 || this.alertParameters.isRequestFromSendTextAlertForm == true) {
                this.getScheduleDetails(this.alertParameters.scheduleId);
            }
            else {
                if (this.alertParameters.dispatchId > 0) {
                    this._scheduleDataService.getDispatch(this.alertParameters.dispatchId).subscribe((dispatchData) => {
                        this.getScheduleDetails(dispatchData.scheduleId);
                    })
                }
            }
        }
    }

    hasAnyFilterSelected(): boolean {
        const hasDestinations = this.destinations?.some(d => d.selected === true) || false;
        const hasOrigins = this.origins?.some(o => o.selected === true) || false;
        const hasCommodities = this.commodities?.some(c => c.selected === true) || false;

        return hasDestinations || hasOrigins || hasCommodities;
    }

    private getScheduleDetails(scheduleId: number) {
        const schedule$ = this.alertParameters.isRequestFromSendTextAlertForm ? of(null) : (scheduleId > 0 ? this._scheduleDataService.getSchedule(scheduleId) : of(null));
        const currentUser$ = this._userDataService.getCurrentUser();

        const param = this.createScheduleParameters();
        param.truckerCode = this.alertParameters.truckerId;
        param.whetherFilterIfTruckerIdIsNotAvailable = this.alertParameters.isRequestFromSendTextAlertForm ? false : true;

        const truckerRequest$ = this._scheduleDataService.getFilteredTruckers(param);
        const originAndestinationRequest$ = this._scheduleDataService.getOriginAndDestinationListForTruckers(param);
        const commoditiesRequest$ = this._scheduleDataService.getCommoditiesForTruckers(param);

        forkJoin([schedule$, currentUser$]).subscribe({
            next: ([schedule, currentUser]) => {
                this.schedule = schedule;
                if (!this.alertParameters.isRequestFromSendTextAlertForm && !this.schedule) {
                    this.response = {
                        data: "Error occurred while fetching schedule details.",
                        status: "Error",
                    };
                    return;
                }
                else {
                    let subject = "Scoular Alert: ";
                    if (this.schedule != null && this.schedule?.scheduleBeginDate != null) {
                        subject = subject + this.formatDate(this.schedule.scheduleBeginDate);
                    }
                    else {
                        subject = subject + "Period between " + this.convertDateString(this.alertParameters.periodStartDate) + " and " + this.convertDateString(this.alertParameters.periodEndDate);

                    }
                    this.emailForm.patchValue({ subject: subject });
                    this.emailForm.patchValue({ closing: "Thanks, \n" + currentUser.userName });
                    this.getAllUsers();
                }
                forkJoin([truckerRequest$, originAndestinationRequest$, commoditiesRequest$]).subscribe({
                    next: ([truckerResponse, originAndestinationResponse, commoditiesResponse]) => {

                        const proceededData = this.processTruckerAndContactsInfo(truckerResponse);
                        this.truckers = proceededData.map((trucker: AlertTruckerFilteredTruckersContactInfo) => ({
                            customerId: trucker.customerId,
                            truckerName: trucker.truckerName,
                            mainContact: trucker.mainContact,
                            phone: trucker.phone,
                            email: trucker.email,
                            isTruckerSelected: false,
                            whetherToConsiderEmail: trucker.email !== "",
                            isTruckerAdded: false,
                            whetherToConsiderPhone: trucker.phone !== ""
                        }));
                        this.origins = originAndestinationResponse.filter(x => x.isOriginLocation == true);
                        this.destinations = originAndestinationResponse.filter(x => x.isOriginLocation == false);

                        this.commodities = commoditiesResponse;
                    },
                    error: (err) => {
                        this.errorMessage = err;
                    },
                });
            },
            error: (err) => {
                this.errorMessage = err;

            },
        });
    }

    convertDateString(dateInput: string): string {
        const [year, month, day] = dateInput.split('-');
        return `${month}/${day}/${year}`;
    }

    private resetComponent() {
        this.intializeEmailForm();
        this.truckers = [];
        this.ccValid = null;
        this.bccValid = null;
        this.manuallyBCCEnteredEmails = [];
        this.manuallyCCEnteredEmails = [];
        this.formStatus = FormStatus.Normal;
        this.truckerSelectedMessage = "No truckers selected";
        this.response = { data: "", status: "" };
        this.isAccordianOpen = false;
        this.resetCategories();
        this.selectorTitle = "";
        this.selectedTruckerInfoContactList = [];
        this.contactAllSelected = false;
        this.originAllSelected = false;
        this.commoditiesAllSelected = false;
        this.destinationAllSelected = false;
        this.userToNotifyAll = false;
        this.searchTerm = "";
        this.isLoadingTruckerContactInfo = false;
    }

    private intializeEmailForm() {
        this.emailForm = this.formBuilder.group({
            bcc: ["", []],
            cc: ["", []],
            closing: [""],
            subject: [""],
            message: ["", [Validators.required, Validators.maxLength(this.messageMaxLength)]],
            telephone: [""]
        });
    }

    getAllUsers() {
        const locCode = this.alertParameters.selectedLocCodeInFilter;
        this._userDataService.getUsers(locCode, true).subscribe({
            next: (data) => {
                this.users = data;
                this.searchedUsers = data;
            },
            error: (err) => (this.errorMessage = err),
        });
    }

    searchByUser(term: string) {
        this.searchTerm = term.toLowerCase();
        this.searchedUsers = this.users.filter(item =>
            item.userName?.toLocaleLowerCase().includes(this.searchTerm))
    }

    //Bcc Methods
    get bccAddress() {
        return this.emailForm.get('bcc');
    }

    getBCCUsersBtnDisabledStatus(): boolean {
        return this.truckers?.filter(x => x.isTruckerSelected)?.length === 0;
    }

    updateManuallyBCCEnteredEmails(value: string): void {
        value = value.includes(";") ? value : value + ";";
        const emailArray = value.split(';').map(email => email.trim()).filter(Boolean);

        this.manuallyBCCEnteredEmails = emailArray.filter(
            email => !this.users.some(user => user.userEmail === email)
        );

        const hasError = emailArray.some(email =>
            Validators.email(new FormControl(email?.trim()))
        );
        this.bccValid = !hasError;
    }

    addSelectedUserToBCC(): void {
        const selectedEmails = this.truckers.filter(x => x.isTruckerSelected && x.whetherToConsiderEmail).map(x => x.email?.trim()).filter(Boolean);
        const selectedPhones = this.truckers.filter(x => x.isTruckerSelected && x.whetherToConsiderPhone).map(x => x.phone?.trim()).filter(Boolean);

        this.manuallyBCCEnteredEmails = this.manuallyBCCEnteredEmails.filter(email => !this.truckers.some(trucker => trucker.email === email));

        const combinedEmails = Array.from(new Set([...selectedEmails, ...this.manuallyBCCEnteredEmails.map(x => x?.trim())]));
        const uniquePhones = Array.from(new Set(selectedPhones.flatMap(p => p.split(',').map(pn => pn.trim()))));

        this.emailForm.patchValue({ bcc: combinedEmails.join(";"), telephone: uniquePhones.join(";") });
        this.truckers.forEach(trucker => { trucker.isTruckerAdded = trucker.isTruckerSelected; });

        this.getTotalBccUsersAdded();
    }

    selectAllLastUserInBCC(event: Event): void {
        const isChecked = (event.target as HTMLInputElement).checked;

        this.truckers.forEach(trucker => { trucker.isTruckerSelected = isChecked; trucker.isTruckerAdded = isChecked; trucker.whetherToConsiderPhone = !!trucker.phone; trucker.whetherToConsiderEmail = !!trucker.email; });

        if (isChecked) {
            this.addSelectedUserToBCC();
        } else {
            this.emailForm.patchValue({ bcc: "", telephone: "" });
            this.getTotalBccUsersAdded();
        }
    }

    unselectLastUserInBCC(event: Event, trucker: AlertTruckerFilteredTruckersContactInfo): void {
        const isChecked = (event.target as HTMLInputElement).checked;
        if (isChecked) return;

        trucker.isTruckerSelected = false;
        trucker.isTruckerAdded = false;

        const email = trucker.email?.trim();
        const emailStillUsed = this.truckers.some(t => t !== trucker && t.isTruckerSelected && t.whetherToConsiderEmail && t.email?.trim() === email);

        if (!emailStillUsed && email) {
            const bccList = (this.emailForm.get('bcc')?.value || "").split(";").map(e => e.trim()).filter(Boolean);
            this.emailForm.patchValue({ bcc: bccList.filter(e => e !== email).join(";") });
        }

        const phoneList = trucker.phone?.split(",").map(p => p.trim()) || [];
        let currentPhones = (this.emailForm.get('telephone')?.value || "").split(";").map(p => p.trim()).filter(Boolean);

        for (const phone of phoneList) {
            const stillUsed = this.truckers.some(t => t !== trucker && t.isTruckerSelected && t.whetherToConsiderPhone && t.phone?.includes(phone));
            if (!stillUsed) {
                currentPhones = currentPhones.filter(p => p !== phone);
            }
        }

        this.emailForm.patchValue({ telephone: currentPhones.join(";") });

        this.getTotalBccUsersAdded();
        this.contactAllSelected = this.truckers.every(t => t.isTruckerSelected);
    }

    onEmailCheckboxChange(event: Event, trucker: AlertTruckerFilteredTruckersContactInfo): void {
        const isChecked = (event.target as HTMLInputElement).checked;
        trucker.whetherToConsiderEmail = isChecked;

        if (!isChecked) {
            const email = trucker.email?.trim();
            const isStillUsed = this.truckers.some(t => t !== trucker && t.isTruckerSelected && t.whetherToConsiderEmail && t.email?.trim() === email);

            if (!isStillUsed && email) {
                const bcc = (this.emailForm.get('bcc')?.value || "").split(";").map(e => e.trim()).filter(Boolean);
                this.emailForm.patchValue({ bcc: bcc.filter(e => e !== email).join(";") });
            }
        }
    }

    onPhoneCheckboxChange(event: Event, trucker: AlertTruckerFilteredTruckersContactInfo): void {
        const isChecked = (event.target as HTMLInputElement).checked;
        trucker.whetherToConsiderPhone = isChecked;

        if (!isChecked) {
            const phoneList = trucker.phone?.split(",").map(p => p.trim()) || [];
            let phones = (this.emailForm.get('telephone')?.value || "").split(";").map(p => p.trim()).filter(Boolean);

            for (const phone of phoneList) {
                const stillUsed = this.truckers.some(t => t !== trucker && t.isTruckerSelected && t.whetherToConsiderPhone && t.phone?.includes(phone));
                if (!stillUsed) {
                    phones = phones.filter(p => p !== phone);
                }
            }

            this.emailForm.patchValue({ telephone: phones.join(";") });
        }
    }

    getTotalBccUsersAdded(): void {
        const count = this.truckers.filter(x => x.isTruckerAdded).length;
        this.truckerSelectedMessage = count > 0 ? ` ${count} Truckers selected` : 'No truckers selected';
    }

    //Cc Methods
    get ccAddress() {
        return this.emailForm.get('cc');
    }

    getCCUsersBtnDisabledStatus(): boolean {
        return this.users?.filter(x => x.selected)?.length == 0;
    }

    selectAllUserToNotify(): void {
        this.users.forEach(element => { element.selected = this.userToNotifyAll; });

        if (this.userToNotifyAll) {
            const selectedEmails = this.users.filter(x => x.userEmail?.trim()).map(x => x.userEmail.trim());
            const combinedEmails = Array.from(new Set([...selectedEmails, ...this.manuallyCCEnteredEmails.map(x => x?.trim())]));

            this.emailForm.patchValue({ cc: combinedEmails.join(";") });
        } else {
            this.emailForm.patchValue({ cc: "" });
        }
    }

    updateManuallyCCEnteredEmails(value: string): void {
            value = value.includes(";") ? value : value.toString() + ";";//to handle the case when only one email address is there.
            const emailArray = value.split(';').map(email => email.trim()).filter(email => email !== '');
            this.manuallyCCEnteredEmails = emailArray.filter(email => !this.users.some(user => user.userEmail == email));
            const hasError = emailArray.some((email) =>  Validators.email(new FormControl(email?.trim())));
            this.ccValid = hasError ? false : true;
    }

    addSelectedUserToCC(): void {
        const selectedEmails = this.users.filter(x => x.selected == true).map(x => x.userEmail?.trim());
        const combinedEmails = Array.from(new Set([...selectedEmails, ...this.manuallyCCEnteredEmails.map(x => x?.trim())]));
        this.emailForm.patchValue({ cc: combinedEmails?.join(";") });
    }

    unselectLastUserInCC(event: Event, user: AlertTruckerUserItem) {
        const isChecked = (event.target as HTMLInputElement).checked;

        if (!isChecked) {
            const lastSelectedUserEmail = user.userEmail?.trim();
            const ccUsersFromField = this.emailForm.get('cc')?.value || "";
            const ccUsersArray = ccUsersFromField.split(";").map(x => x.trim()).filter(Boolean);
            const updatedCcUsers = ccUsersArray.filter(email => email !== lastSelectedUserEmail);

            this.emailForm.patchValue({ cc: updatedCcUsers.join(";") });

            user.selected = false;
            this.userToNotifyAll = this.users.every(u => u.selected === true);
        }
    }

    // Accordian Filter Methods
    private resetCategories() {
        this.categories = [
            { name: 'Destinations', items: [] },
            { name: 'Origins', items: [] },
            { name: 'Commodities', items: [] }
        ];
    }

    formatDate(inputDate: string): string {
        const date = new Date(inputDate);
        const monthName = this.getMonthName(date);
        return `Week of ${monthName} ${date.getDate()}`;
    }

    getMonthName(date: Date): string {
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const monthIndex = date.getMonth();

        // Return the month name
        return monthNames[monthIndex];
    }

    getSelectorTitle() {
        let origins = "";
        let destinations = "";
        let commodities = "";
        if (this.categories.find(category => category.name == "Destinations")?.items?.length > 0) {
            destinations = "<b>Destinations:  </b>" + this.categories.find(category => category.name == "Destinations")?.items?.map(x => x)?.join(",");
        }
        if (this.categories.find(category => category.name == "Origins")?.items?.length > 0) {
            origins = " <b>Origins:  </b>" + this.categories.find(category => category.name == "Origins")?.items?.map(x => x)?.join(",");
        }
        if (this.categories.find(category => category.name == "Commodities")?.items?.length > 0) {
            commodities = " <b>Commodities:  </b>" + this.categories.find(category => category.name == "Commodities")?.items?.map(x => x)?.join(",");
        }
        this.selectorTitle = `${destinations} ${origins} ${commodities}`;
    }

    unCheckAll() {
        this.destinations.forEach(item => item.selected = false);
        this.origins.forEach(item => item.selected = false);
        this.commodities.forEach(item => item.selected = false);
        this.selectorTitle = "";
        this.selectedTruckerInfoContactList = [];
        this.resetCategories();
        this.originAllSelected = false;
        this.commoditiesAllSelected = false;
        this.destinationAllSelected = false;
    }

    selectAllInFilterForDestination(event: Event, section: string, datalist: AlertTruckerLocationListItem[]) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.destinations.forEach(element => {
            element.selected = isChecked;
        });

        this.processDestinationOrOriginHeaderData(isChecked, datalist, section);
    }

    selectAllInFilterForOrigin(event: Event, section: string, datalist: AlertTruckerLocationListItem[]) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.origins.forEach(element => {
            element.selected = isChecked;
        });

        this.processDestinationOrOriginHeaderData(isChecked, datalist, section);
    }

    selectAllInFilterForCommodity(event: Event, section: string, datalist: CommodityListItem[]) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.commodities.forEach(element => {
            element.selected = isChecked;
        });

        if (isChecked) {
            datalist.forEach(element => {
                if (this.categories.find(x => x.name == section).items.filter(c => c == element.commodityCode).length == 0) {
                    this.categories.find(x => x.name == section).items.push(element.commodityCode);
                }
            });
        }
        else {
            const category = this.categories.find(x => x.name == section);
            if (category) {
                this.categories.find(x => x.name == section).items = [];
            }
        }
        this.processContactInfo();
    }

    private processDestinationOrOriginHeaderData(isChecked: boolean, datalist: AlertTruckerLocationListItem[], section: string) {
        if (isChecked) {
            datalist.forEach(element => {
                if (this.categories.find(x => x.name == section).items.filter(c => c == element.locationName).length == 0) {
                    this.categories.find(x => x.name == section).items.push(element.locationName);
                }
            });
        }
        else {
            const category = this.categories.find(x => x.name == section);
            if (category) {
                this.categories.find(x => x.name == section).items = [];
            }
        }
        this.processContactInfo();
    }

    showMoreDetails(rowSelectionId: number | string, rowTitle: string, tabName: string) {
        this.resetCategories();
        this.selectorTitle = `${tabName}: ${rowTitle}`;
        let newParams = this.createScheduleParameters();
        newParams.commodityCode = tabName == 'Commodities' ? rowSelectionId.toString().trim() : "";
        newParams.originId = 0;
        newParams.destinationId = 0;
        newParams.locationId = 0;
        newParams.truckerCode = 0;
        //newParams.customerId = this.alertParameters.customerId;
        newParams.originId = tabName == 'Commodities' ? 0 : (tabName == 'Origins' ? Number(rowSelectionId) : 0);
        newParams.destinationId = tabName == 'Commodities' ? 0 : (tabName == 'Origins' ? 0 : Number(rowSelectionId));
        newParams.whetherFilterIfTruckerIdIsNotAvailable = false;
        this.isLoadingTruckerContactInfo = true;
        this._scheduleDataService
            .getFilteredTruckers(newParams)
            .subscribe({
                next: (data) => {
                    this.selectedTruckerInfoContactList = [];
                    this.selectedTruckerInfoContactList = this.processTruckerAndContactsInfo(data);
                    this.isLoadingTruckerContactInfo = false;
                },
                error: (err) => {
                    this.errorMessage = err;
                    this.isLoadingTruckerContactInfo = false;
                },
            });
    }

    appendMoreDetails(event: Event, rowTitle: string, tabName: string) {
        this.selectorTitle = "";
        const isChecked = (event.target as HTMLInputElement).checked;
        if (isChecked) {
            this.categories.find(x => x.name == tabName).items.push(rowTitle);
        }
        else {
            const category = this.categories.find(x => x.name == tabName);
            if (category) {
                category.items = category.items.filter(item => item !== rowTitle);
            }
        }

        this.processContactInfo();

        if (tabName == "Destinations") {
            if (this.destinations.filter(b => b.selected == false)?.length > 0) {
                this.destinationAllSelected = false;
            }
        }
        else if (tabName == "Origins") {
            if (this.origins.filter(b => b.selected == false)?.length > 0) {
                this.originAllSelected = false;
            }
        }
        else if (tabName == "Commodities") {
            if (this.commodities.filter(b => b.selected == false)?.length > 0) {
                this.commoditiesAllSelected = false;
            }
        }
    }

    private processContactInfo() {
        const selectedDestinations = this.destinations.filter(d => d.selected == true).map(i => i.id);
        const selectedOrigins = this.origins.filter(d => d.selected == true).map(i => i.id);
        const selectedCommodities = this.commodities.filter(d => d.selected == true).map(i => i.commodityCode);
        if (!(selectedCommodities?.length == 0 && selectedDestinations?.length == 0 && selectedOrigins?.length == 0)) {
            let newParams = this.createScheduleParameters();
            newParams.commodityCodeList = selectedCommodities;
            newParams.locationId = 0;
            newParams.truckerCode = 0;
            newParams.commodityCode = "";
            //newParams.customerId = this.alertParameters.customerId;
            newParams.originIdList = selectedOrigins;
            newParams.destinationIdList = selectedDestinations;
            newParams.whetherFilterIfTruckerIdIsNotAvailable = false;
            this.isLoadingTruckerContactInfo = true;
            this._scheduleDataService
                .getFilteredTruckers(newParams)
                .subscribe({
                    next: (data) => {
                        this.getSelectorTitle();
                        this.selectedTruckerInfoContactList = this.processTruckerAndContactsInfo(data);
                        this.isLoadingTruckerContactInfo = false;
                    },
                    error: (err) => {
                        this.errorMessage = err;
                        this.isLoadingTruckerContactInfo = false;
                    },
                });
        }
        else {
            this.getSelectorTitle();
            this.selectedTruckerInfoContactList = [];
        }
    }

    //Misc Methods
    sendEmailAndTextMessage(): void {
        const bcc = this.emailForm.get("bcc")?.value;
        const cc = this.emailForm.get("cc")?.value;
        const subject = this.emailForm.get("subject").value;
        const message = this.emailForm.get("message").value;
        const closing = this.emailForm.get("closing").value;
        const telephone = this.emailForm.get("telephone").value;

        if (message == "") {
            this.response = {
                data: "Please enter the message.",
                status: "Error",
            };
            return;
        }

        if (bcc?.length > 0 || cc?.length > 0) {
            if (subject == "") {
                this.response = {
                    data: "Please enter the subject of the email.",
                    status: "Error",
                };
                return;
            }

            if (closing == "") {
                this.response = {
                    data: "Please enter the closing note.",
                    status: "Error",
                };
                return;
            }
        }

        if (bcc?.length == 0 && cc?.length == 0 && telephone == "") {
            this.response = {
                data: "Please enter/ select atleast one telephone number or a valid email address",
                status: "Error",
            };
            return;
        }

        const phoneContactMap: { [phone: string]: string } = {};
        this.truckers.filter(t => t.isTruckerAdded && t.whetherToConsiderPhone).forEach(trucker => {
            const phones = trucker.phone?.split(',').map(p => p.trim()) || [];
            phones.forEach(phone => {
                phoneContactMap[phone] = `${trucker.mainContact}`;
            });
        });

        if (this.emailForm.valid) {
            const messageInfo = {
                From: "",
                To: "",
                CC: cc,
                BCC: bcc,
                Subject: subject,
                Body: message,
                Telephone: this.emailForm.get("telephone")?.value,
                Attachment: "",
                ClosingNote: closing,
                ProcessName: "AlertTruckerForm",
                DispatchId: this.alertParameters.dispatchId.toString(),
                PhoneContactMap: phoneContactMap
            };

            messageInfo.CC = messageInfo.CC?.replace(/,/g, ';');
            messageInfo.BCC = messageInfo.BCC?.replace(/,/g, ';');
            this._messageService.sendEmailAndTextMessage(messageInfo).subscribe({
                next: (data) => {
                    this.response = {
                        data: data,
                        status: data.toLowerCase().indexOf("failed") > -1 ? "Error" : "Success",
                    };
                    if (data.toLowerCase().indexOf("success") > -1) {
                        this.sendComplete.emit(this.alertParameters.scheduleId);
                        setTimeout(() => {
                            this.closeButton.nativeElement.click();
                        }, 3000);
                    }

                },
                error: (err) => {
                    this.response = {
                        data: "Error occurred, please try again",
                        status: "Error",
                    };
                },
            });
        }
        else {
            this.response = {
                data: "Please enter valid details.",
                status: "Error",
            };
        }
    }

    applyAll() {
        this.truckers = [];
        if (this.selectedTruckerInfoContactList) {
            this.selectedTruckerInfoContactList.forEach(element => {

                element.whetherToConsiderPhone = element.phone !== "";
                element.whetherToConsiderEmail = element.email !== "";
                this.truckers.push(element);
            });
        }
        this.truckers = Array.from(this.truckers.reduce((map, item) => {
            const key = `${item.email}|${item.customerId}|${item.mainContact}`;
            return map.set(key, item)
        }, new Map()).values());
        this.isAccordianOpen = !this.isAccordianOpen;
        this.contactAllSelected = false;
    }

    // getOriginsAndDestinations() {
    //   var param = this.createScheduleParameters();
    //   this._scheduleDataService.getOriginAndDestinationListForTruckers(param).subscribe({
    //     next: (data) => {
    //       this.origins = data.filter(x => x.isOriginLocation == true);
    //       this.destinations = data.filter(x => x.isOriginLocation == false);
    //     },
    //     error: (err) => (this.errorMessage = err),
    //   });
    // }

    private createScheduleParameters() {
        var param = new ScheduleParameters();
        param.locCode = this.alertParameters.selectedLocCodeInFilter;
        param.locationType = this.alertParameters.locationType;
        param.periodStartDate = this.alertParameters.periodStartDate;
        param.periodEndDate = this.alertParameters.periodEndDate;
        param.shipThroughDate = this.alertParameters.periodEndDate;
        return param;
    }

    processTruckerAndContactsInfo(data: FilteredTruckersInfo[]): AlertTruckerFilteredTruckersContactInfo[] {
        const uniqueContactsMap = new Map<string, any>();
        data.forEach(trucker => {
            if (trucker?.contacts?.length > 0) {
                trucker.contacts.forEach(contact => {
                    let phone = trucker.telephone1 ?? trucker.telephone2;
                    if (contact.isPhone1TextEnabled == true && contact.isPhone2TextEnabled == true) {
                        if (contact.phone1 || contact.phone2) {
                            phone = [contact.phone1, contact.phone2].filter(Boolean).join(', ');
                        }
                    }
                    else if (contact.isPhone1TextEnabled == true) {
                        phone = contact.phone1;
                    }
                    else if (contact.isPhone2TextEnabled == true) {
                        phone = contact.phone2;
                    }

                    const contactInfo = {
                        customerId: trucker.customerId,
                        truckerName: trucker.customerName,
                        mainContact: contact.contactName,
                        phone: phone,
                        email: contact.email != '' ? contact.email : trucker.email
                    };
                    const contactIdentifier = `${contactInfo.truckerName}-${contactInfo.mainContact}-${contactInfo.email}`;

                    // Add contact to the map if it doesn't exist
                    if (!uniqueContactsMap.has(contactIdentifier)) {
                        uniqueContactsMap.set(contactIdentifier, contactInfo);
                    }
                });

            } else {
                const contactInfo = {
                    customerId: trucker.customerId,
                    truckerName: trucker.customerName,
                    mainContact: "-",
                    phone: trucker.telephone1 || trucker.telephone2,
                    email: trucker.email
                };
                const contactIdentifier = `${contactInfo.truckerName}-${contactInfo.mainContact}-${contactInfo.email}`;

                // Add contact to the map if it doesn't exist
                if (!uniqueContactsMap.has(contactIdentifier)) {
                    uniqueContactsMap.set(contactIdentifier, contactInfo);
                }
            }
        });
        const _tempSelectedTruckerInfoContactList = Array.from(uniqueContactsMap.values());
        return _tempSelectedTruckerInfoContactList.sort((a, b) => {
            const nameComparison = a.truckerName.localeCompare(b.truckerName);
            if (nameComparison !== 0) {
                return nameComparison;
            }
            return a.mainContact.localeCompare(b.mainContact);
        });
    }
} 